import React from 'react';
import gql from 'graphql-tag';
import compose from '../../../../src/web/utils/react/compose';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import BlogHome from './BlogHome';
import { NAME, ID } from './properties';
import useQuery from '../../../../modules/react/hooks/useQuery';
import useCurrentPageData from '../../../../modules/react/hooks/useCurrentPageData';

const GET_BLOG_DATA = gql`
  query GetBlogHomeData($postSortParameters: BlogPostsSortInput) {
    currentSite {
      id
      ...BlogHomeBlogSettings
    }
    blogPosts(sortParameters: $postSortParameters) {
      edges {
        node {
          id
          ...BlogHomeBlogPosts
        }
      }
    }
    blogCategories {
      ...BlogHomeBlogCategories
    }
  }

  ${BlogHome.fragments.settings}
  ${BlogHome.fragments.posts}
  ${BlogHome.fragments.categories}
`;

const BlogHomeContainer = () => {
  const { slug } = useCurrentPageData();
  const { data } = useQuery(
    GET_BLOG_DATA,
    {
      variables: {
        postSortParameters: {
          sortBy: 'date',
          sortDirection: -1,
        },
      },
    },
  );
  const posts = data?.blogPosts?.edges.map(({ node }) => node) || [];
  return (
    <BlogHome
      pageSlug={slug}
      posts={posts}
      title={data?.currentSite.blogSettings.title}
      categories={data?.blogCategories}
    />
  );
};

export default compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    {
      menu: false,
    },
  ),
)(BlogHomeContainer);
